import { render } from "./complete.vue?vue&type=template&id=3fffbaa3"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__